import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
`;

const Logo = styled.img`
  width: 120px;
  height: 120px;
  padding: 20px;
  border-radius: 50%;
  object-fit: contain;
  animation: ${pulse} 1.2s infinite;
  background-color: #fff;
`;

export default function Loader() {
  return (
    <LoaderWrapper>
      <Logo
        src={`${process.env.PUBLIC_URL}/images/logo-full.png`}
        alt="Loading..."
      />
    </LoaderWrapper>
  );
}
